import axios from 'axios'
import { ssoBaseUrl } from '../resources/api-constants'
import { toCamelCase, toSnackCase } from './functions'

const sso22Axios = axios.create({
    baseURL: ssoBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
})

sso22Axios.interceptors.response.use(
    (response) => {
        response.data = toCamelCase(response.data)
        return response
    },
    async (error) => {
        return Promise.reject(error)
    }
)

sso22Axios.interceptors.request.use(
    (config) => {
        config.data = toSnackCase(config.data)
        return config
    },
    async (error) => {
        return Promise.reject(error)
    }
)

export default sso22Axios
